import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { GenerationsService } from 'shared/services/generation.service';
import { TGenerations } from 'shared/services/types/generations.types';

export const useGenerationsActions = () => {
  const queryClient = useQueryClient();

  const startGeneration = useMutation({
    mutationFn: (data: TGenerations.startGenerations) => GenerationsService.startGenerations(data),
    mutationKey: ['start generation']
  });

  const checkGeneration = useQuery({
    queryFn: () => GenerationsService.checkIsGeneration(),
    queryKey: ['check generation'],
    retry: 0,
    select: ({ data }) => data
  });

  const stopGeneration = useMutation({
    mutationFn: () => GenerationsService.stopGenerations(),
    mutationKey: ['stop generation']
  });

  return { startGeneration, checkGeneration, stopGeneration };
};
